import ErrorTooltip from 'Components/ErrorTooltip';
import env from 'environment_system/env_system';
import { Field, FieldProps, useFormikContext } from 'formik';
import { checkForNaN, isFormUnchanged } from 'GenericForms/Helper';
import React, { useEffect } from 'react'
import { Input } from 'reactstrap';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

const SpOpEnergyConsumptionComponent = ({
    energyConsumptions,
    handleChange,
    AuxEngineMaxSFOC,
    kwhMeterPopup,
    editValues,
    setEditValues,
    spOpConstant
}: any) => {
    const { initialValues, values, errors }: { initialValues: any, values: any, errors: any } = useFormikContext();
    const { discardwarning } = useEditReport();

    useEffect(() => {
        if (editValues && Array.isArray(editValues?.chief_engineer?.special_operation_energy) &&
            !isFormUnchanged(initialValues?.withkWhMeter?.functional, values?.withkWhMeter?.functional)) {
            setEditValues({
                ...editValues,
                chief_engineer: {
                    ...editValues?.chief_engineer,
                    special_operation_energy: [
                        ...editValues?.chief_engineer?.special_operation_energy?.filter((item: any) => item.special_operation !== spOpConstant),
                        ...values?.withkWhMeter?.functional?.filter((item: any) => item.special_operation === spOpConstant)
                    ]
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.withkWhMeter?.functional])
    return (
        <React.Fragment>
            <div className='d-inline-block'>
                <div className="input-group">
                    <Field name={`withkWhMeter.functional.${values.withkWhMeter.functional.indexOf(energyConsumptions)}.energy_consumed`}>
                        {({ field, form }: FieldProps) => (
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control max-width-7 text-right"
                                id={`energy_consumed-${values.withkWhMeter.functional.indexOf(energyConsumptions)}`}
                                name={field.name}
                                onChange={(e: any) => {
                                    handleChange(e);
                                    form.setFieldValue(
                                        `withkWhMeter.functional.${values?.withkWhMeter?.functional?.indexOf(energyConsumptions)}.equivalent_fuel_consumption`,
                                        checkForNaN(
                                            (checkForNaN(AuxEngineMaxSFOC?.max_eedi_eexi_technical_file) * checkForNaN(e.target.value) / 1000000), 4
                                        )
                                    );
                                }}
                                onBlur={(e: any) => {
                                    handleChange(e);
                                    form.setFieldValue(
                                        `withkWhMeter.functional.${values?.withkWhMeter?.functional?.indexOf(energyConsumptions)}.equivalent_fuel_consumption`,
                                        checkForNaN(
                                            (checkForNaN(AuxEngineMaxSFOC?.max_eedi_eexi_technical_file) * checkForNaN(e.target.value) / 1000000), 4
                                        )
                                    );
                                }}
                                disabled={
                                    values?.withkWhMeter?.functional[values?.withkWhMeter?.functional?.indexOf(energyConsumptions)]?.is_kwh_meter_not_functional
                                }
                                value={values?.withkWhMeter?.functional[values?.withkWhMeter?.functional?.indexOf(energyConsumptions)]?.energy_consumed}
                            />
                        )}
                    </Field>
                    <div className="input-group-text">kWh</div>
                </div>
            </div>
            {errors?.withkWhMeter && errors?.withkWhMeter?.functional &&
                errors?.withkWhMeter?.functional[values?.withkWhMeter?.functional?.indexOf(energyConsumptions)] &&
                errors?.withkWhMeter?.functional[values?.withkWhMeter?.functional?.indexOf(energyConsumptions)]?.energy_consumed &&
                env?.form_validation === true && !discardwarning &&
                <ErrorTooltip
                    target={`energy_consumed-${values.withkWhMeter.functional.indexOf(energyConsumptions)}`}
                    message={errors?.withkWhMeter?.functional[values?.withkWhMeter?.functional?.indexOf(energyConsumptions)]?.energy_consumed}
                    open={errors?.withkWhMeter?.functional[values?.withkWhMeter?.functional?.indexOf(energyConsumptions)]?.energy_consumed && !kwhMeterPopup ? true : false}
                />
            }
        </React.Fragment>
    )
}

export default SpOpEnergyConsumptionComponent